module.exports = {
    "page.lu.feedback.subtitle": "感谢您抽出时间给我们反馈。\n我们将利用您的反馈来改善每个人的 Lazada 体验。",
    "page.asc.onboarding.feedback.subtitle": "欢迎加入Lazada，我们在这里为您提供帮助。\n请填写此表单以告知我们您在登录或注册账户时遇到的问题。\n此外，如果您有任何建议或想法，也请随时写下来。",
    "page.asc.feedback.emailHolder": "请正确填写，我们的团队可能会通过这种方式与您联系。",
    "page.asc.feedback.descHolder": "请与我们分享更多细节。",
    "page.common.needhelp": "需要帮助",
    "page.asc.feedback.phoneHolder": "请正确填写，我们的团队可能会通过这种方式与您联系。",
    "layout.toolbar.feedback.freezen.title": "反馈",
    "page.asc.feedback.title": "反馈表单"
};